angular.module('leanlaw').controller('ConflictMatterViewCtrl', ['$scope', '$state', '$stateParams', 'userService', 'leanLawApi', 'matterManager', 'lists', function ($scope, $state, $stateParams, userService, leanLawApi, matterManager, lists) {
  matterManager.get($stateParams.id).then(matter => {
    $scope.matter = matter;
  });
  $scope.gotoMatter = function (matter) {
    return $state.go('matters-next.client.matter', {
      id: matter.client.id,
      matterId: matter.id
    });
  };
}]);